"use strict";

angular.module("customer")
.factory("CartItemService", function(
    $resource, $http, $rootScope, $q, $state, $timeout, FlashBag, gettextCatalog, UserService, StocksService,
    DiscountCalculatorFactory, Rollbar, appConfig,
    PatternService, common, moment,
    SHIPPING_RATE_METHOD_PER_ORDER, SHIPPING_RATE_METHOD_PER_AMOUNT, SHIPPING_RATE_METHOD_PER_REGION_AND_WEIGHT
) {
    var cartPromises = [];

    function isOnDeliverySelected(vendor) {
        return moment().tz(vendor.timezone).format("YYYY-MM-DD") === vendor.delivery_date;
    }

    function updateCartItemSubTotal(cartItem, vendor) {
        var catalogEntry = cartItem.catalog_entry;
        var catalogEntryVariant = cartItem.catalog_entry_variant;
        var product = catalogEntry.product;

        cartItem.price = catalogEntry.price;
        if (vendor.allow_product_variants && catalogEntry.product.has_variants && catalogEntryVariant) {
            cartItem.price = catalogEntryVariant.price;
        }
        else if (cartItem.is_custom_discounted_price) {
            cartItem.price = catalogEntry.custom_discounted_price;
        }
        else if (catalogEntry.discount !== null) {
            var discount = new DiscountCalculatorFactory(catalogEntry.discount.discount_type, catalogEntry.discount.discount_value);
            var discountResult = discount.getCatalogEntryResult(cartItem.price);

            cartItem.catalogEntryDiscountResult = discountResult;
            cartItem.price = discountResult.discounted_price;
            cartItem.catalogEntryTotalSavings = discountResult.discount_amount * cartItem.quantity;
        }
        if (!cartItem.is_return && catalogEntry.rebate_amount) {
            cartItem.catalogEntryTotalRebate = catalogEntry.rebate_amount * cartItem.quantity;
        }
        else {
            cartItem.catalogEntryTotalRebate = 0;
        }

        var quantity = cartItem.quantity;
        var price = cartItem.price;
        cartItem.pricePerUnitOfMeasure = cartItem.price / product.measure_per_each;
        if (vendor.enable_product_measure_management && product.is_variable_measure) {
            quantity = cartItem.quantity * product.measure_per_each;
            if (cartItem.is_custom_discounted_price) {
                cartItem.pricePerUnitOfMeasure = catalogEntry.custom_discounted_price;
            }
            else {
                cartItem.pricePerUnitOfMeasure = catalogEntry.price_per_unit_of_measure;
            }
            price = cartItem.pricePerUnitOfMeasure;

            if (isOnDeliverySelected(vendor)) {
                quantity = cartItem.total_measure;
            }

            if (catalogEntry.discount !== null) {
                if (catalogEntry.discount.discount_type === "discount_percent") {
                    var discount_amount_per_unit_of_measure = discountResult.discount_amount / product.measure_per_each;
                    cartItem.catalogEntryTotalSavings = discount_amount_per_unit_of_measure * cartItem.total_measure;
                    cartItem.showDiscountPerUnitOfMeasure = true;
                }
                else if (catalogEntry.discount.discount_type === "rebate_percent") {
                    var rebate_per_unit_of_measure = discountResult.rebate_amount / product.measure_per_each;
                    cartItem.catalogEntryTotalSavings = rebate_per_unit_of_measure * cartItem.total_measure;
                    cartItem.showDiscountPerUnitOfMeasure = false;
                }
            }
        }

        cartItem.subtotal = quantity * price;
    }

    function getTaxes(amount, isTaxable) {
        return $http({
            method: "get",
            url: appConfig.API_SERVER + "/auth/taxes/",
            ignoreLoadingBar: true,
            params: {
                taxable: isTaxable,
                amount: amount
            }
        })
    }

    function setShippingFee(order, shoppingCart) {
        function setFee(fee, order, shoppingCart, fee_with_tax) {
            fee_with_tax = fee_with_tax || fee;

            order.shippingFee = fee;
            order.subtotal += fee;
            order.total += fee_with_tax;
            shoppingCart.totalShippingFee += order.shippingFee;
            shoppingCart.subTotal += fee;
            shoppingCart.cartTotalAmount += fee_with_tax;
        }

        var deferred = $q.defer();
        var fee = calculateShippingFee(order);

        if (fee > 0) {
            $http({
                method: "get",
                url: appConfig.API_SERVER + "/auth/taxes/",
                params: {
                    taxable: true,
                    amount: fee
                }
            }).then(function(result) {
                setFee(fee, order, shoppingCart, result.data.total);
                deferred.resolve(true);
            });
        }
        else {
            setFee(fee, order, shoppingCart);
            deferred.resolve(true);
        }
        return deferred.promise;
    }

    function calculateShippingFee(order) {
        var fee = 0;
        var subTotalAmount = order.subtotal;
        var totalSalesUnitOfMeasure = order.totalSalesUnitOfMeasure;

        if (order.salesItemExists) {
            angular.forEach(order.shipping_rates, function(shippingRate) {
                if (shippingRate.method === SHIPPING_RATE_METHOD_PER_ORDER) {
                    fee += shippingRate.rules[0].amount;
                }
                else if (shippingRate.method === SHIPPING_RATE_METHOD_PER_AMOUNT) {
                    for (var i = 0; i != shippingRate.rules.length; i++) {
                        if (
                            shippingRate.rules[i].minimum_threshold == subTotalAmount
                            || shippingRate.rules[i].maximum_threshold == subTotalAmount
                            || (
                                shippingRate.rules[i].minimum_threshold < subTotalAmount
                                && subTotalAmount < shippingRate.rules[i].maximum_threshold
                            )
                            || (
                                shippingRate.rules[i].minimum_threshold < subTotalAmount
                                && shippingRate.rules[i].maximum_threshold == null
                            )
                        ) {
                            fee += shippingRate.rules[i].amount;
                            break;
                        }
                    }
                }
                else if (shippingRate.method === SHIPPING_RATE_METHOD_PER_REGION_AND_WEIGHT) {
                    angular.forEach(totalSalesUnitOfMeasure, function(totalWeight, unitOfMeasureCode) {
                        for (var i = 0; i != shippingRate.rules.length; i++) {
                            if (
                                unitOfMeasureCode === shippingRate.unit_of_measure_code
                                && (
                                    shippingRate.rules[i].minimum_threshold == totalWeight
                                    || shippingRate.rules[i].maximum_threshold == totalWeight
                                    || (
                                        shippingRate.rules[i].minimum_threshold < totalWeight
                                        && totalWeight < shippingRate.rules[i].maximum_threshold
                                    )
                                    || (
                                        shippingRate.rules[i].minimum_threshold < totalWeight
                                        && shippingRate.rules[i].maximum_threshold == null
                                    )
                                )
                            ) {
                                fee += shippingRate.rules[i].amount;
                                break;
                            }
                        }
                    });
                }
            });
        }
        return fee;
    }

    function updateCart(shoppingCart) {
        shoppingCart.itemsCount = 0;
        shoppingCart.cartTotalAmount = 0;
        shoppingCart.returnCartTotalAmount = 0;
        shoppingCart.cartTotalRebate = 0;
        shoppingCart.subTotal = 0;
        shoppingCart.returnSubTotal = 0;
        shoppingCart.totalShippingFee = 0;
        var promises = [];
        var deferred = $q.defer();

        shoppingCart.forEach(function(vendor) {
            vendor.orders.forEach(function(order) {
                order.total = 0;
                order.returnTotal = 0;
                order.subtotal = 0;
                order.returnSubTotal = 0;
                order.rebate = 0;
                order.totalSalesUnitOfMeasure = {};
                order.deposits = {};
                order.returnDeposits = {};
                order.salesItemExists = false;
                order.cart_items.forEach(function(cartItem) {
                    updateCartItemSubTotal(cartItem, vendor);
                    if (
                        !cartItem.is_return
                        && vendor.enable_product_measure_management
                    ) {
                        if (!order.totalSalesUnitOfMeasure.hasOwnProperty(cartItem.catalog_entry.product.unit_of_measure.code)) {
                            order.totalSalesUnitOfMeasure[cartItem.catalog_entry.product.unit_of_measure.code] = 0;
                        }
                        if (isOnDeliverySelected(vendor)) {
                            order.totalSalesUnitOfMeasure[cartItem.catalog_entry.product.unit_of_measure.code] += parseFloat(cartItem.total_measure);
                        }
                        else {
                            order.totalSalesUnitOfMeasure[cartItem.catalog_entry.product.unit_of_measure.code] += parseFloat(cartItem.catalog_entry.product.measure_per_each * cartItem.quantity);
                        }
                    }

                    if (cartItem.is_return) {
                        order.returnSubTotal += cartItem.subtotal;
                    }
                    else {
                        order.salesItemExists = true;
                        order.subtotal += cartItem.subtotal;
                    }

                    var isTaxable = vendor.enable_order_tax_management && cartItem.catalog_entry.product.taxable;
                    var promise = getTaxes(cartItem.subtotal, isTaxable);
                    promises.push(promise);
                    promise.then(function(taxes) {
                        cartItem.TaxResult = taxes.data;
                        var cartItemTotal = parseFloat(cartItem.TaxResult.total);
                        if (cartItem.is_return) {
                            order.returnTotal += cartItemTotal;
                            shoppingCart.returnCartTotalAmount += cartItemTotal;
                        }
                        else {
                            order.total += cartItemTotal;
                            shoppingCart.cartTotalAmount += cartItemTotal;
                        }
                        order.rebate += cartItem.catalogEntryTotalRebate;
                        shoppingCart.cartTotalRebate += cartItem.catalogEntryTotalRebate;
                        shoppingCart.itemsCount += parseFloat(cartItem.quantity);
                        return deferred.resolve(true);
                    });

                    if (cartItem.catalog_entry.product && cartItem.catalog_entry.product.product_deposits && cartItem.catalog_entry.product.product_deposits.length) {
                        cartItem.catalog_entry.product.product_deposits.forEach(function(productDeposit) {
                            var depositQuantity = cartItem.quantity / productDeposit.deposits_per_package;
                            if (depositQuantity) {
                                var depositAmount = depositQuantity * productDeposit.price
                                if (cartItem.is_return) {
                                    if (!order.returnDeposits.hasOwnProperty(productDeposit.deposit_product_id)) {
                                        order.returnDeposits[productDeposit.deposit_product_id] = {
                                            quantity: 0,
                                            totalAmount: 0,
                                            isTaxable: productDeposit.taxable,
                                            productDeposit: productDeposit,
                                            isReturn: true
                                        }
                                    }
                                    order.returnDeposits[productDeposit.deposit_product_id].quantity += depositQuantity;
                                    order.returnDeposits[productDeposit.deposit_product_id].totalAmount += depositAmount;
                                }
                                else {
                                    if (!order.deposits.hasOwnProperty(productDeposit.deposit_product_id)) {
                                        order.deposits[productDeposit.deposit_product_id] = {
                                            quantity: 0,
                                            totalAmount: 0,
                                            isTaxable: productDeposit.taxable,
                                            productDeposit: productDeposit,
                                            isReturn: false
                                        }
                                    }
                                    order.deposits[productDeposit.deposit_product_id].quantity += depositQuantity;
                                    order.deposits[productDeposit.deposit_product_id].totalAmount += depositAmount;
                                }
                            }
                        });
                    }
                });

                if (Object.keys(order.deposits).length > 0) {
                    Object.keys(order.deposits).forEach(function(key) {
                        var deposit = order.deposits[key];
                        var isTaxable = vendor.enable_order_tax_management && deposit.productDeposit.taxable;
                        var promise = getTaxes(deposit.totalAmount, isTaxable);
                        promises.push(promise);
                        promise.then(function(taxes) {
                            order.deposits[key]['TaxResult'] = taxes.data;
                            var productDepositSubTotal = parseFloat(deposit.TaxResult.amount);
                            var productDepositTotal = parseFloat(deposit.TaxResult.total);
                            order.subtotal += productDepositSubTotal;
                            order.total += productDepositTotal;
                            shoppingCart.cartTotalAmount += productDepositTotal;
                            return deferred.resolve(true);
                        });
                    });
                }

                if (Object.keys(order.returnDeposits).length > 0) {
                    Object.keys(order.returnDeposits).forEach(function(key) {
                        var deposit = order.returnDeposits[key];
                        var isTaxable = vendor.enable_order_tax_management && deposit.productDeposit.taxable;
                        var promise = getTaxes(deposit.totalAmount, isTaxable);
                        promises.push(promise);
                        promise.then(function(taxes) {
                            order.returnDeposits[key]['TaxResult'] = taxes.data;
                            var productDepositSubTotal = parseFloat(deposit.TaxResult.amount);
                            var productDepositTotal = parseFloat(deposit.TaxResult.total);
                            order.returnSubTotal += productDepositSubTotal;
                            order.returnTotal += productDepositTotal;
                            shoppingCart.returnCartTotalAmount += productDepositTotal;
                            return deferred.resolve(true);
                        });
                    });
                }

                $q.all(promises).then(function() {
                    shoppingCart.subTotal += order.subtotal;
                    setShippingFee(order, shoppingCart).then(function onSuccess() {
                        order.subtotal -= order.returnSubTotal;
                        order.total -= order.returnTotal;
                        shoppingCart.subTotal -= order.returnSubTotal;
                        shoppingCart.cartTotalAmount -= shoppingCart.returnCartTotalAmount;
                    });
                });
            });
        });
    }

    function isCartItemQuantityValid(min, max, quantity) {
        if (min === null && max === null) {
            return true;
        }

        // We allow 0 (we use it to clear carts too)
        if (quantity == 0 || quantity === undefined) {
            return true;
        }

        if (quantity < 0) {
            return false;
        }

        if (min !== null && quantity < min) {
            return false;
        }

        if (max !== null && quantity > max) {
            return false;
        }

        return true;
    }

    function isProductMultiplierValid(packaging_quantity, quantity) {
        return !(quantity % packaging_quantity);
    }

    function isProductInventoryQuantityValid(inventoryQuantity, orderedQuantity) {
        return typeof inventoryQuantity === "number" ? orderedQuantity <= inventoryQuantity : true;
    }

    function isProductQuantityPatternValid(orderedQuantity) {
        return PatternService.orderedQuantity.test(orderedQuantity);
    }

    function isUnitOfMeasureQuantityPatternValid(unitOfMeasureQuantity) {
        return PatternService.preciseWeightGreaterThanZero.test(unitOfMeasureQuantity);
    }

    function isOrderedWithQuantityOfMeasureValid(catalogEntry, vendor) {
        if (!vendor.enable_product_measure_management) {
            return true;
        }

        var orderedQuantity = parseFloat(catalogEntry.order_quantity);
        var totalMeasure = parseFloat(catalogEntry.total_measure);
        return (
            !catalogEntry.product.is_variable_measure
            || !isOnDeliverySelected(vendor)
            || (
                catalogEntry.product.is_variable_measure
                && (
                    (orderedQuantity > 0 && totalMeasure > 0)
                    || (orderedQuantity === 0 && totalMeasure === 0)
                )
            )
        );
    }

    function isDiscountedWithQuantityOfMeasureValid(catalogEntry, vendor, quantity, totalMeasure) {
        if (!vendor.enable_product_measure_management) {
            return true;
        }

        return (
            !catalogEntry.product.is_variable_measure
            || !isOnDeliverySelected(vendor)
            || (
                catalogEntry.product.is_variable_measure
                && (
                    (quantity > 0 && totalMeasure > 0)
                    || (quantity === 0 && totalMeasure === 0)
                )
            )
        );
    }

    function isOrderedValueMissingWithQuantityOfMeasure(catalogEntry, vendor) {
        return (
            vendor.enable_product_measure_management
            && catalogEntry.product.is_variable_measure
            && parseFloat(catalogEntry.order_quantity) === 0
            && parseFloat(catalogEntry.total_measure) > 0
            && isOnDeliverySelected(vendor)
        );
    }

    function isDiscountedValueMissingWithQuantityOfMeasure(catalogEntry, vendor) {
        return (
            vendor.enable_product_measure_management
            && catalogEntry.product.is_variable_measure
            && parseFloat(catalogEntry.discounted_order_quantity) === 0
            && parseFloat(catalogEntry.discounted_total_measure) > 0
            && isOnDeliverySelected(vendor)
        );
    }

    function isSalesQuantityValid(catalogEntry, catalogEntryVariant, quantity, vendor) {
        var isProductVariant = !!(vendor.allow_product_variants && catalogEntry.product.has_variants && catalogEntryVariant);
        catalogEntry.order_quantity = quantity;
        var isQuantityValid = isCartItemQuantityValid(catalogEntry.quantity_min, catalogEntry.quantity_max, catalogEntry.order_quantity);
        var isMultiplierValid = isProductMultiplierValid(catalogEntry.packaging_quantity, catalogEntry.order_quantity);
        var totalQuantity = parseFloat(catalogEntry.order_quantity);
        if (typeof catalogEntry.discounted_order_quantity !== 'undefined') {
            totalQuantity += parseFloat(catalogEntry.discounted_order_quantity);
        }
        var isInventoryQuantityValid = isProductInventoryQuantityValid(catalogEntry.inventory_quantity, totalQuantity);
        if (isProductVariant) {
            isInventoryQuantityValid = (
                isProductInventoryQuantityValid(catalogEntryVariant.inventory_quantity, totalQuantity)
            );
        }
        var isQuantityPatternValid = isProductQuantityPatternValid(catalogEntry.order_quantity);

        if (vendor.is_order_template) {
            isInventoryQuantityValid = true;
        }

        return isQuantityValid && isMultiplierValid && isQuantityPatternValid && (
            !vendor.is_cart_vendor_exists
            || !vendor.block_order_when_out_of_stock
            || isInventoryQuantityValid
        );
    }

    function isDiscountedQuantityValid(catalogEntry, catalogEntryVariant, quantity, vendor) {
        catalogEntry.discounted_order_quantity = quantity;
        var isQuantityValid = isCartItemQuantityValid(
            catalogEntry.quantity_min,
            catalogEntry.quantity_max,
            catalogEntry.discounted_order_quantity
        );
        var isMultiplierValid = isProductMultiplierValid(
            catalogEntry.packaging_quantity,
            catalogEntry.discounted_order_quantity
        );
        var totalQuantity = parseFloat(catalogEntry.order_quantity);
        if (typeof catalogEntry.discounted_order_quantity !== 'undefined') {
            totalQuantity += parseFloat(catalogEntry.discounted_order_quantity);
        }
        var isInventoryQuantityValid = isProductInventoryQuantityValid(
            catalogEntry.inventory_quantity,
            totalQuantity
        );
        var isQuantityPatternValid = isProductQuantityPatternValid(catalogEntry.discounted_order_quantity);

        return isQuantityValid && isMultiplierValid && isQuantityPatternValid && (
            !vendor.is_cart_vendor_exists
            || !vendor.block_order_when_out_of_stock
            || isInventoryQuantityValid
        );
    }

    function updateSalesQuantity(vendor, quantity, catalogEntry, catalogEntryVariant) {
        var quantityObject = updateQuantityObject(catalogEntry, quantity, false);
        return updateQuantity(appConfig.API_SERVER + "/catalog/cart/items/:id/", vendor, quantityObject, catalogEntry, catalogEntryVariant);
    }

    function updateReturnQuantity(vendor, quantity, catalogEntry, catalogEntryVariant) {
        var quantityObject = updateQuantityObject(catalogEntry, quantity, false);
        return updateQuantity(appConfig.API_SERVER + "/catalog/cart/returns/items/:id/", vendor, quantityObject, catalogEntry, catalogEntryVariant);
    }

    function updateInventoryReturnQuantity(vendor, quantity, catalogEntry, catalogEntryVariant) {
        var quantityObject = updateQuantityObject(catalogEntry, quantity, false);
        return updateQuantity(appConfig.API_SERVER + "/catalog/cart/inventory-returns/items/:id/", vendor, quantityObject, catalogEntry, catalogEntryVariant);
    }

    function updateDiscountedQuantity(vendor, quantity, catalogEntry, catalogEntryVariant, customDiscountedPrice) {
        var quantityObject = updateDiscountedQuantityObject(catalogEntry, quantity, false, null, customDiscountedPrice);
        return updateQuantity(appConfig.API_SERVER + "/catalog/cart/discounts/items/:id/", vendor, quantityObject, catalogEntry, catalogEntryVariant);
    }

    function saveUnitOfMeasureQuantity(quantity, catalogEntry, catalogEntryVariant, cartItem, url, vendor) {
        var isQuantityValid = isUnitOfMeasureQuantityPatternValid(quantity);
        if (parseFloat(quantity) === 0 || isQuantityValid) {
            var quantityObject = updateQuantityObject(catalogEntry, quantity, true, cartItem);
            return updateQuantity(url, vendor, quantityObject, catalogEntry, catalogEntryVariant);
        }
        else {
            return scrollToError(catalogEntry);
        }
    }

    function saveCustomDiscountedUnitOfMeasureQuantity(
        quantity, catalogEntry, catalogEntryVariant, cartItem, url, vendor, customDiscountedPrice
    ) {
        var isQuantityValid = isUnitOfMeasureQuantityPatternValid(quantity);
        if (parseFloat(quantity) === 0 || isQuantityValid) {
            var quantityObject = updateDiscountedQuantityObject(catalogEntry, quantity, true, cartItem, customDiscountedPrice);
            return updateQuantity(url, vendor, quantityObject, catalogEntry, catalogEntryVariant);
        }
        else {
            return scrollToError(catalogEntry);
        }
    }

    function saveOrderedUnitOfMeasureQuantity(catalogEntry, catalogEntryVariant, quantity, vendor, cartItem) {
        var url = appConfig.API_SERVER + "/catalog/cart/items/:id/";
        return saveUnitOfMeasureQuantity(quantity, catalogEntry, catalogEntryVariant, cartItem, url, vendor);
    }

    function saveReturnUnitOfMeasureQuantity(catalogEntry, catalogEntryVariant, quantity, vendor, cartItem) {
        var url = appConfig.API_SERVER + "/catalog/cart/returns/items/:id/";
        return saveUnitOfMeasureQuantity(quantity, catalogEntry, catalogEntryVariant, cartItem, url, vendor);
    }

    function saveInventoryReturnUnitOfMeasureQuantity(catalogEntry, catalogEntryVariant, quantity, vendor, cartItem) {
        var url = appConfig.API_SERVER + "/catalog/cart/inventory-returns/items/:id/";
        return saveUnitOfMeasureQuantity(quantity, catalogEntry, catalogEntryVariant, cartItem, url, vendor);
    }

    function saveDiscountedUnitOfMeasureQuantity(
        catalogEntry, catalogEntryVariant, quantity, vendor, cartItem, customDiscountedPrice
    ) {
        var url = appConfig.API_SERVER + "/catalog/cart/discounts/items/:id/";
        return saveCustomDiscountedUnitOfMeasureQuantity(quantity, catalogEntry, catalogEntryVariant, cartItem, url, vendor, customDiscountedPrice);
    }

    function saveSaleQuantity(catalogEntry, catalogEntryVariant, quantity, vendor) {
        if (!isSalesQuantityValid(catalogEntry, catalogEntryVariant, quantity, vendor)) {
            return scrollToError(catalogEntry);
        }

        return updateSalesQuantity(vendor, quantity, catalogEntry, catalogEntryVariant)
        .then(function onSuccess(response) {
            if (response) {
                if (response.total_measure === undefined) {
                    catalogEntry.total_measure = 0;
                }
                else {
                    catalogEntry.total_measure = parseFloat(response.total_measure);
                }
            }
        });
    }

    function saveDiscountedQuantity(catalogEntry, catalogEntryVariant, quantity, vendor, customDiscountedPrice) {
        if (!isDiscountedQuantityValid(catalogEntry, catalogEntryVariant, quantity, vendor)) {
            return scrollToError(catalogEntry);
        }

        return updateDiscountedQuantity(vendor, quantity, catalogEntry, catalogEntryVariant, customDiscountedPrice)
        .then(function onSuccess(response) {
            if (response) {
                if (response.total_measure === undefined) {
                    catalogEntry.discounted_total_measure = 0;
                }
                else {
                    catalogEntry.discounted_total_measure = parseFloat(response.total_measure);
                }
            }
        });
    }

    function saveReturnQuantity(catalogEntry, catalogEntryVariant, quantity, vendor) {
        catalogEntry.order_quantity = quantity;
        return updateReturnQuantity(vendor, quantity, catalogEntry, catalogEntryVariant);
    }

    function saveInventoryReturnQuantity(catalogEntry, catalogEntryVariant, quantity, vendor) {
        catalogEntry.order_quantity = quantity;
        return updateInventoryReturnQuantity(vendor, quantity, catalogEntry, catalogEntryVariant);
    }

    function updateQuantityObject(catalogEntry, quantity, isQuantityOfUnitOfMeasure, cartItem) {
        if (isQuantityOfUnitOfMeasure) {
            var orderedQuantity = (typeof catalogEntry.order_quantity === 'undefined') ? cartItem.quantity : catalogEntry.order_quantity;
            return {
                "quantity": orderedQuantity,
                "totalMeasure": quantity,
                "updateQuantityOfUnitOfMeasure": true
            }
        }
        return {
            "quantity": quantity,
            "totalMeasure": catalogEntry.total_measure,
            "updateQuantityOfUnitOfMeasure": false
        }
    }

    function updateDiscountedQuantityObject(
        catalogEntry, quantity, isQuantityOfUnitOfMeasure, cartItem, customDiscountedPrice
    ) {
        if (isQuantityOfUnitOfMeasure) {
            var discountedQuantity = (typeof catalogEntry.discounted_order_quantity === 'undefined') ? cartItem.quantity : catalogEntry.discounted_order_quantity;
            return {
                "quantity": discountedQuantity,
                "totalMeasure": quantity,
                "customDiscountedPrice": customDiscountedPrice,
                "updateQuantityOfUnitOfMeasure": true
            }
        }
        return {
            "quantity": quantity,
            "totalMeasure": catalogEntry.discounted_total_measure,
            "customDiscountedPrice": customDiscountedPrice,
            "updateQuantityOfUnitOfMeasure": false
        }
    }

    function updateQuantity(url, vendor, quantityObject, catalogEntry, catalogEntryVariant) {
        var service = $resource(url, {
            id: "@id"
        }, {
            query: {
                method: "get",
                isArray: true,
                ignoreLoadingBar: true
            },
            update: {
                method: "PATCH",
                ignoreLoadingBar: true
            },
            delete: {
                method: "DELETE",
                ignoreLoadingBar: true
            }
        });
        return UserService.isUserFetched().then(function onSuccess(user) {
            var deferred = $q.defer();
            if (!StocksService.validateDeliveryDate(vendor)) {
                return deferred.reject;
            }

            function updateAndResolve(object) {
                if (
                    user && user.info && user.info.customer_use_quick_order
                    && $state.$current.name === "stocks"
                ) {
                    var isOnDelivery = isOnDeliverySelected(vendor);
                    if (
                        !catalogEntry.product.is_variable_measure
                        || (
                            catalogEntry.product.is_variable_measure && !isOnDelivery
                        )
                        || (
                            catalogEntry.product.is_variable_measure && isOnDelivery
                            && parseFloat(quantityObject['totalMeasure']) > 0
                        )
                    ) {
                        $timeout(function() {
                            angular.element(".SearchBox:visible").first().focus().select();
                        });
                    }
                }
                $rootScope.UpdateCartItemsNumber(true);
                deferred.resolve(object);
            }

            if (parseFloat(quantityObject['quantity']) === 0) {
                var params = {catalog_entry: catalogEntry.id};
                if (vendor.allow_product_variants && catalogEntry.product.has_variants && catalogEntryVariant) {
                    params['catalog_entry_variant'] = catalogEntryVariant.id;
                }
                service.query(params, function(cartItems) {
                    if (cartItems.length !== 0) {
                        return service.get({
                            id: cartItems[0].id
                        }).$promise.then(function(cartItem) {
                            return cartItem.$delete().then(
                                updateAndResolve,
                                function onError(response) {
                                    if (response.status === 403 || response.status === 400) {
                                        FlashBag.apiError(response);
                                    }
                                    deferred.reject(response);
                                }
                            );
                        });
                    }
                });

                return deferred.promise;
            }

            var cartItem = new service();
            if (
                vendor.enable_product_measure_management
                && catalogEntry.product
                && catalogEntry.product.is_variable_measure
                && isOnDeliverySelected(vendor)
            ) {
                delete cartItem.total_measure;
                cartItem.total_measure = 0;
                if (parseFloat(quantityObject['totalMeasure']) > 0) {
                    cartItem.total_measure = quantityObject['totalMeasure'];
                }
            }

            if ('customDiscountedPrice' in quantityObject) {
                cartItem.custom_discounted_price = quantityObject['customDiscountedPrice'];
            }

            cartItem.quantity = quantityObject['quantity'];
            cartItem.catalog_entry = catalogEntry.id;
            if (vendor.allow_product_variants && catalogEntry.product.has_variants && catalogEntryVariant) {
                cartItem.catalog_entry_variant = catalogEntryVariant.id;
            }
            cartItem.$save().then(updateAndResolve, function onError(response) {
                common.scrollToTop();
                FlashBag.apiError(response);
                deferred.reject(response);
            });
            return deferred.promise;
        });
    }

    function scrollToError(catalogEntry) {
        common.scrollTo("#error-product" + catalogEntry.id);
        var deferred = $q.defer();
        deferred.reject();
        return deferred.promise;
    }

    function removePromiseWhenCompleted(promise, allPromises) {
        promise.finally(function() {
            var index = allPromises.indexOf(promise);
            if (index > -1) {
                allPromises.splice(index, 1);
            }
        });
    }

    function usePreviousOrder(params) {
        return $http({
            method: "POST",
            url: appConfig.API_SERVER + "/catalog/cart/vendors/use-previous-order/",
            data: params
        });
    }

    return {
        fetchCart: function() {
            var deferred = $q.defer();

            $q.all(cartPromises).then(function() {
                $resource(appConfig.API_SERVER + "/catalog/cart/", {}, {
                    query: {
                        method: "GET",
                        isArray: true
                    }
                }).query({}, function(data) {
                    updateCart(data);
                }, function(response) {
                    FlashBag.apiError(response);
                }).$promise.then(deferred.resolve, deferred.reject);
            });
            return deferred.promise;
        },
        isAvailable: function(min, max) {
            if (min !== null && max !== null && min > max)
                return false;
            // This item is no longer available.
            return max !== 0;
        },
        getMinMaxError: function(min, max) {
            var min_max = [];

            if (min !== null)
                min_max.push("Min: " + min);

            if (max !== null)
                min_max.push("Max: " + max);

            return " (" + min_max.join(", ") + ")";
        },
        getQuantityMinMaxError: function(min, max) {
            if (!this.isAvailable(min, max))
                return gettextCatalog.getString("This item is no longer available.");

            var msg = gettextCatalog.getString("The quantity is invalid.");
            return msg + this.getMinMaxError(min, max);
        },
        getProductMultiplierError: function(packaging_quantity) {
            var msg = gettextCatalog.getString("Your quantity must fit with the packaging quantity.");
            return msg + " " + packaging_quantity;
        },
        isOrderAmountValid: function(order) {
            var min = order.min_per_order;
            var max = order.max_per_order;

            if ((min || max) && order.cart_items.length) {
                var total = order.total;

                if (min && total < min)
                    return false;
                if (max && total > max)
                    return false;
            }

            return true;
        },
        isOrderQuantityValid: function(order) {
            var min = order.qty_min_per_order;
            var max = order.qty_max_per_order;

            if ((min || max) && order.cart_items.length) {
                var total = 0;

                for (var index in order.cart_items) {
                    total += order.cart_items[index].quantity;
                }

                if (min && total < min)
                    return false;
                if (max && total > max)
                    return false;
            }

            return true;
        },
        getOrderAmountError: function(order) {
            var min = order.min_per_order;
            var max = order.max_per_order;

            var msg = gettextCatalog.getString("The order amount is invalid.");
            return msg + this.getMinMaxError(min, max);
        },
        getOrderQuantityError: function(order) {
            var min = order.qty_min_per_order;
            var max = order.qty_max_per_order;

            var msg = gettextCatalog.getString("The order quantity is invalid.");
            return msg + this.getMinMaxError(min, max);
        },
        getProductInventoryQuantityError: function(inventory_quantity) {
            if (inventory_quantity > 0) {
                return gettextCatalog.getString("Quantity left in stock is {{inventoryQuantity}}.", {inventoryQuantity: inventory_quantity});
            }
            else if (inventory_quantity === 0) {
                return gettextCatalog.getString("This item is out of stock.");
            }
        },
        getProductQuantityPatternError: function() {
            return gettextCatalog.getString("Only positive number with two decimal places are allowed.");
        },
        getOrderedValueMissingWithQuantityOfMeasureError: function() {
            return gettextCatalog.getString("You need to order the product to change the Quantity of Unit of Measure.");
        },
        getUnitOfMeasureQuantityPatternError: function() {
            return gettextCatalog.getString("Only positive number with three decimal places are allowed.");
        },
        updateCart: updateCart,
        updateSalesQuantity: updateSalesQuantity,
        updateReturnQuantity: updateReturnQuantity,
        updateDiscountedQuantity: updateDiscountedQuantity,
        updateInventoryReturnQuantity: updateInventoryReturnQuantity,
        isProductMultiplierValid: isProductMultiplierValid,
        isProductInventoryQuantityValid: isProductInventoryQuantityValid,
        isProductQuantityPatternValid: isProductQuantityPatternValid,
        isUnitOfMeasureQuantityPatternValid: isUnitOfMeasureQuantityPatternValid,
        isCartItemQuantityValid: isCartItemQuantityValid,
        saveSaleQuantity: saveSaleQuantity,
        saveReturnQuantity: saveReturnQuantity,
        saveInventoryReturnQuantity: saveInventoryReturnQuantity,
        saveDiscountedQuantity: saveDiscountedQuantity,
        saveOrderedUnitOfMeasureQuantity: saveOrderedUnitOfMeasureQuantity,
        saveReturnUnitOfMeasureQuantity: saveReturnUnitOfMeasureQuantity,
        saveInventoryReturnUnitOfMeasureQuantity: saveInventoryReturnUnitOfMeasureQuantity,
        saveDiscountedUnitOfMeasureQuantity: saveDiscountedUnitOfMeasureQuantity,
        usePreviousOrder: usePreviousOrder,
        isOnDeliverySelected: isOnDeliverySelected,
        isOrderedWithQuantityOfMeasureValid: isOrderedWithQuantityOfMeasureValid,
        isDiscountedWithQuantityOfMeasureValid: isDiscountedWithQuantityOfMeasureValid,
        isOrderedValueMissingWithQuantityOfMeasure: isOrderedValueMissingWithQuantityOfMeasure,
        isDiscountedValueMissingWithQuantityOfMeasure: isDiscountedValueMissingWithQuantityOfMeasure
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/cart/cart-item.service.js
// module id = 932
// module chunks = 0